<template>
  <petition-lockable-field-layout :field-name="fieldName" :label="label" :show-lock="showLock"
                                  :can-change-lock="fieldCanBeLocked" :initial-locked="initialLocked"
                                  :input-id="inputId" :required="required"
                                  :lock-update-path="lockUpdatePath">
    <template #readonly-field>
      <text-input :multiline="multiline" :value="value" disabled readonly :validation-errors="validationErrors"
                  :input-id="inputId" :input-name="inputName" :show-label="false" :rows="inputRows" />
      <input type="hidden" :name="inputName" :value="value">
    </template>
    <template #editable-field>
      <text-input :multiline="multiline" :value="value" :validation-errors="validationErrors"
                  :input-id="inputId" :input-name="inputName" :show-label="false" :rows="inputRows"
                  :max-length="maxLength" @changed="updateFieldValue" />
    </template>
  </petition-lockable-field-layout>
</template>

<script>
import FieldWithLock from '@/mixins/field-with-lock'
import { Popover } from 'bootstrap'
import TextInput from '@/components/inputs/text-input'
import snakeCase from 'lodash/snakeCase'
import PetitionLockableFieldLayout from '@/components/petition-lockable-field-layout'

export default {
  components: { PetitionLockableFieldLayout, TextInput },

  mixins: [FieldWithLock],

  props: {
    fieldName: {
      type: String,
      required: true
    },
    helpPopoverContent: {
      type: String,
      required: false
    },
    hideHelpPopover: {
      type: Boolean,
      required: true
    },
    initialValue: {
      type: String,
      required: false
    },
    label: {
      type: String,
      required: true
    },
    maxLength: {
      type: Number,
      required: false
    },
    multiline: {
      type: Boolean,
      required: false,
      default: false
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    validationErrors: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      inputRows: this.multiline ? 6 : 1,
      value: this.initialValue
    }
  },

  computed: {
    fieldCanBeLocked() {
      // Not required fields can be locked even if they are empty
      return this.canChangeLock && (!this.required || this.value?.length > 0)
    },
    inputName() {
      return `petition[${this.fieldName}]`
    },
    inputId() {
      return snakeCase(this.inputName)
    }
  },

  mounted() {
    this.initializePopover()
  },

  methods: {
    initializePopover() {
      if (this.hideHelpPopover || !this.inputId) {
        return
      }

      // TODO: DRY with app/javascript/popovers.js (?)
      const popoverTemplate = '<div class="popover" role="tooltip"><div class="popover-arrow"></div><div class="popover-inner"><div class="popover-body"><p></p></div></div></div>'
      const inputEl = document.getElementById(this.inputId)

      new Popover(inputEl, {
        content: this.helpPopoverContent,
        placement: 'right',
        html: true,
        template: popoverTemplate,
        trigger: 'focus'
      })
    },

    updateFieldValue(newValue) {
      this.value = newValue
    }
  }
}
</script>
